import React from 'react'
import { CSSTransition } from 'react-transition-group'

const Transition = ({
  buttonEl,
  nodeRef,
  show,
  onClose,
  enter,
  enterFrom,
  enterTo,
  leave,
  leaveFrom,
  leaveTo,
  children,
}) => {
  const enterClasses = enter.split(' ')
  const enterFromClasses = enterFrom.split(' ')
  const enterToClasses = enterTo.split(' ')
  const leaveClasses = leave.split(' ')
  const leaveFromClasses = leaveFrom.split(' ')
  const leaveToClasses = leaveTo.split(' ')

  // Ability to close the menu by clicking outside the menu or hitting the ESC key
  React.useEffect(() => {
    if (show && onClose) {
      const handleClickOutside = (event) => {
        if (
          !nodeRef?.current?.contains(event.target) &&
          !buttonEl?.contains(event.target)
        ) {
          onClose()
        }
      }

      const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
          onClose()
        }
      }

      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('keydown', handleKeyDown)

      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
        document.removeEventListener('keydown', handleKeyDown)
      }
    }
  }, [nodeRef, buttonEl, show, onClose])

  return (
    <CSSTransition
      unmountOnExit
      nodeRef={nodeRef}
      in={show}
      addEndListener={(done) => {
        nodeRef.current.addEventListener('transitionend', done, false)
      }}
      onEnter={() => {
        nodeRef.current.classList.add(...enterClasses, ...enterFromClasses)
      }}
      onEntering={() => {
        nodeRef.current.classList.remove(...enterFromClasses)
        nodeRef.current.classList.add(...enterToClasses)
      }}
      onEntered={() => {
        nodeRef.current.classList.remove(...enterToClasses, ...enterClasses)
      }}
      onExit={() => {
        nodeRef.current.classList.add(...leaveClasses, ...leaveFromClasses)
      }}
      onExiting={() => {
        nodeRef.current.classList.remove(...leaveFromClasses)
        nodeRef.current.classList.add(...leaveToClasses)
      }}
      onExited={() => {
        nodeRef.current.classList.remove(...leaveToClasses, ...leaveClasses)
      }}
    >
      {children}
    </CSSTransition>
  )
}

export default Transition
